<template>
  <el-container class="only-screen-width">
    <pg-menu :isCollapse="menuCollapse" :toggleNav="toggleNav"/>
    <div class="contain-width native-body" :class="{ push: !menuCollapse }">
      <transition name="app-header">
        <div v-if="showHeader">
          <el-header class="native-header">
            <pg-header :toggleNav="toggleNav" :hideMenu="hideMenu" />
          </el-header>
        </div>
      </transition>
      <el-main>
        <div class="inner">
          <div class="nav-mask" v-if="!menuCollapse" @click="menuCollapse = true"></div>
          <transition :name="transitionName" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </el-main>
      <phone-menu :hideMenu="hideMenu" @toggleNav="toggleNav" :active="!menuCollapse" />
    </div>
  </el-container>
</template>

<script>
import Menu from '@/components/dashboard/Menu'
import Header from '@/components/dashboard/Header'
import PhoneMenu from '@/components/dashboard/PhoneMenu'

export default {
  components: { 'pg-menu': Menu, 'pg-header': Header, PhoneMenu },
  name: 'dashboard',
  data () {
    return {
      menuCollapse: true,
      transitionName: 'jump'
    }
  },
  computed: {
    showHeader () {
      if (this.$screen.mobile && this.$route.name === 'stations') {
        return false
      }

      return true
    },
    hideMenu () {
      let isAdmin = this.$root.userOrganizations.find(u => u.isOrganizationAdmin)
      return this.$screen.mobile && (isAdmin === undefined) && !this.$root.isSystem
    }
  },
  methods: {
    toggleNav () {
      this.menuCollapse = !this.menuCollapse
    }
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length

      if (toDepth > fromDepth) {
        this.transitionName = 'page-push'
      } else if (toDepth < fromDepth) {
        this.transitionName = 'page-pop'
      } else {
        this.transitionName = 'page-jump'
      }
    }
  },
  created () {
    console.log(this.$screen.mobile)
  }
}
</script>

<style lang="scss" scoped>
  .nav-mask {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 60px;
    bottom: 0;
    z-index: 99999999;
  }

  .mobile-header {
    display: none;
  }

  @include breakpoint (xs) {
    .mobile-header {
      display: block;
    }

    .only-screen-width {
      width: 100%;
      overflow-x: hidden;
    }

    .nav-mask {
      display: block;
    }


    .contain-width {    
      position: relative;
      min-width: 100vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue